import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { vehicleColumns } from '@Constants/TableColumns';
import { type ApiOrder, type ApiVehicle, EnumFrontendLayoutSetting } from '@Model';
import { FrameEditVehicle } from '@Modules/Stammdaten';
import {
    type AsyncStateUpdate,
    DateInput,
    FloatingCard,
    Grid,
    GridColumns,
    type IGuiBinder,
    useLinkedField,
    useLinkProperty,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

interface IProps {
    binder: IGuiBinder<ApiOrder>;
    baseApiObjectPath: string;
    requestUpdateState: AsyncStateUpdate<ApiOrder>;
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const OrderDispositionSection = memo(function OrderDispositionSection({
    binder,
    baseApiObjectPath,
    requestUpdateState,
}: IProps) {
    const i18n = useTranslate('');

    const linkVehicle = useLinkedField<ApiOrder, ApiVehicle>(
        baseApiObjectPath,
        'vehicle',
        FrameEditVehicle,
        true,
        requestUpdateState,
    );
    const linkTrailer = useLinkedField<ApiOrder, ApiVehicle>(
        baseApiObjectPath,
        'trailer',
        FrameEditVehicle,
        true,
        requestUpdateState,
    );

    const vehicleField = useLinkProperty(binder, linkVehicle.linkApi);
    const trailerField = useLinkProperty(binder, linkTrailer.linkApi);
    const scheduledStartField = useProp(binder, 'scheduled_start');
    const scheduledEndField = useProp(binder, 'scheduled_end');

    return (
        <FloatingCard title="Disposition">
            <Grid>
                <GridColumns spans={[3, 3, 3, 3]}>
                    <LinkedFieldWithLayoutSettings<ApiVehicle>
                        layoutSettingsContext={EnumFrontendLayoutSetting.VehiclesTableLayout}
                        {...vehicleField}
                        {...linkVehicle.events}
                        columns={vehicleColumns}
                        label={i18n('Fahrzeug')}
                    />
                    <LinkedFieldWithLayoutSettings<ApiVehicle>
                        layoutSettingsContext={EnumFrontendLayoutSetting.VehiclesTableLayout}
                        {...trailerField}
                        {...linkTrailer.events}
                        columns={vehicleColumns}
                        label={i18n('Anhänger')}
                    />
                    <DateInput {...scheduledStartField} type="datetime" label="Dispodatum (von)" />
                    <DateInput {...scheduledEndField} type="datetime" label="Dispodatum (bis)" />
                </GridColumns>
            </Grid>
        </FloatingCard>
    );
});
